export default {
  SALES_ORDERS_LIST: "Sales Orders List",
  ADD_SALES_ORDER: "Add Sales Order",
  ADD_SALES_ORDER_ITEM: "Add Line Item",
  SALES_ORDER_ADDED: "Sales Order Added",
  OWNER: "Owner",
  EDIT_SALES_ORDER: "Edit Sales Order",
  SALES_ORDER_UPDATED: "Sales Order Updated",
  BILLING_ADDRESS: "Billing Address",
  EXPIRATION_TIME: "Expiration Date",
  ITEM_TYPE: "Type",
  SELECT_PRODUCTS: "Select a Product",
  SELECT_SUBSCRIPTIONS: "Select a Subscription",
  SELECT_PACKAGES: "Select a Package",
  DELETE_SALES_ORDER_ITEM: "Delete Line Item",
  UPDATE_SALES_ORDER_ITEM: "Update Line Item",
  SALES_ORDER_ITEM_DELETED: "Line Item Deleted",
  SALES_ORDER_ITEM_ADDED: "Line Item Added",
  SALES_ORDER_ITEM_EDITED: "Line Item Updated",
  SEND: "Send",
  CANCEL: "Cancel",
  REFUND: "Refund",
  ADD_PAYMENT: "Add Payment",
  SALES_ORDER_SENT: "Sales Order Sent",
  SELECT_USERS: "Select User",
  SELECT_CUSTOMERS: "Select Customer",
  SELECT_ORGANIZATIONS: "Select Organization",
  SELECT_SUPPLIERS: "Select Supplier",
  DELETE_THIS_SALES_ORDER: "Delete this Sales Order?",
  SALES_ORDER_DELETED: "Sales Order Deleted",
  CANCEL_SALES_ORDER_QUESTION: "Cancel Sales Order?",
  SALES_ORDER_CANCELED: "Sales Order Canceled",
  RECIPIENT: "Recipient",
  ISSUER: "Issuer",
  VALIDATE: "Validate",
  SALES_ORDER_VALIDATED: "Sales Order Validated",
  GENERATE_INVOICE: "Generate Invoice",
  GENERATE_AND_SEND_INVOICE: "Generate and send invoice",
  RESEND_INVOICE: "Resend invoice",
  INVOICING_DATE: "Invoicing date",
  INVOICING_DATE_FALLBACK_WARNING: "Event date is missing — please fix the submission before sending.",
  CONFIRM_RESEND_INVOICE: "This invoice has already been sent. Do you want to resend it?",
  SUBSIDIZED_INVOICE_SENT: "Invoice sent successfully",
  SUBSIDIZED_INVOICE_SENT_WITH_NUMBER: "Invoice {number} sent successfully",
  INVOICE_NUMBER_PLACEHOLDER_HINT:
    "The invoice does not exist yet: its number will be assigned on send and will automatically replace {token} in the subject and message.",
  INVOICE_NUMBER_PLACEHOLDER_REMOVED:
    "The {token} placeholder was removed from both the subject and the message: the invoice number will not appear in the email (it remains on the attached PDF).",
  WARNINGS: {
    MULTIPLE_INVOICES_EXIST: "Multiple invoices already exist for this order. The most recent one was used — please review billing.",
    REUSING_NON_COMPLETE_INVOICE: "A partial invoice was reused instead of creating a new one.",
    INVOICING_DATE_IGNORED: "The provided invoicing date was ignored: an invoice already existed with its own date.",
    STAMP_FAILED_AFTER_SEND: "Invoice was sent, but the send trace could not be recorded. Please contact an administrator before resending to avoid a double send.",
    PREVIOUS_INVOICE_WAS_CANCELED: "A previous invoice had been canceled. A new invoice was generated.",
    PREVIOUS_INVOICE_WAS_DRAFT: "A previous invoice was stuck in draft state. A new invoice was generated.",
  },
  INVOICE_GENERATED: "Invoice Generated",
  VIEW_INVOICE: "View Invoice",
  ADD_DELIVERY: "Add Delivery",
  DELIVERIES_STATE: "Delivery Status",
  DELIVERIES_STATE_ITEM: "Product",
  DELIVERIES_STATE_ORDERED_QUANTITY: "Ordered Quantity",
  DELIVERIES_STATE_DELIVERED_QUANTITY: "Delivered Quantity",
  DELIVERIES_STATE_REMAINING_QUANTITY: "Remaining Quantity",
  NOT_INVOICED: "To Invoice",
  NOT_DELIVERED: "To Deliver",
  DELIVERED: "Delivered",
  SALES_INVOICES: "Sales Invoices",
  ADD_INVOICE: "Add Invoice",
  INVOICING_TYPE: "Invoicing Type",
  INVOICING_TYPE_COMPLETE: "Complete",
  INVOICING_TYPE_AMOUNT: "Amount",
  INVOICING_TYPE_PRODUCT: "Product",
  INVOICING_STATUS_PENDING: "Not Invoiced",
  INVOICING_STATUS_PARTIALLY_INVOICED: "Partially Invoiced",
  INVOICING_STATUS_INVOICED: "Invoiced",
  DELIVERY_STATUS_PENDING: "Not Delivered",
  DELIVERY_STATUS_PARTIALLY_DELIVERED: "Partially Delivered",
  DELIVERY_STATUS_DELIVERED: "Delivered",
  INVOICING_STATUS: "Invoicing Status",
  ORDER_STATUS_DRAFT: "Draft",
  ORDER_STATUS_CANCELED: "Canceled",
  ORDER_STATUS_VALIDATED: "Validated",
  ORDER_STATUS_COMPLETED: "Completed",
  DELIVERY_STATUS: "Delivery Status",
  INVOICE_TYPE: "Invoice Type",
  INVOICE_TYPE_DOWNPAYMENT: "Down Payment Invoice",
  INVOICE_TYPE_STANDARD: "Standard Invoice",
  SALES_ORDER_INVOICE_ADDED: "Invoice Added",
  SALES_ORDER_DELIVERY_ADDED: "Delivery Added",
  EVENT_DATE: "Event Date",
  EVENT_TIME: "Event Time",
  DELIVERY_LOCATION: "Delivery Location",
  SHOW_SALES_ORDER: "View Sales Order",
  SALES_ORDER_DESCRIPTION: "Sales Order Description",
  DOWNLOAD_PDF: "Download PDF",
  PRODUCT_SERVCIE: "Products/Services",
  QTY: "Qty",
  OWED_AMOUNT: "BALANCE DUE",
  VALIDATION: "Validation",
  VALIDATION_MESSAGE: "Validate your order now! You will find all the details of your order on this page. Please verify the information carefully",
  COMMENT: "Comment",
  ACCEPT_TERMS_AND_CONDITIONS: "Accept the terms and conditions",
  ACCEPT: "Accept",
  REFUSE: "Refuse",
  SALES_ORDER_VALIDATED_BO: "Sales Order validated",
  SEND_NOW_QUESTION: "Send the submission now?",
  SEND_NOW_HINT: "You can send the submission to the client right away to avoid forgetting.",
  ALERT_VALIDATE: "Do you really want to <span>ACCEPT</span> this order?",
  ALERT_CANCEL: "Do you really want to <span>REFUSE</span> this order?",
  ACCEPT_VALIDATE: "Yes, accept",
  ACCEPT_CANCEL: "Yes, refuse",
  CLIENT_VALIDATION: "Customer Validation",
  CLIENT_VALIDATED_STATUS_0: "",
  CLIENT_VALIDATED_STATUS_DRAFT: "Draft",
  CLIENT_VALIDATED_STATUS_PENDING: "Pending",
  CLIENT_VALIDATED_STATUS_PENDING_REVISION: "Pending Revision Acceptance",
  CLIENT_VALIDATED_STATUS_CANCELED: "Refused",
  CLIENT_VALIDATED_STATUS_VALIDATED: "Accepted",
  CLIENT_VALIDATED_STATUS_NOT_REQUIRED: "Not required",
  VALIDATED_AT: "Accepted on ",
  CANCELED_AT: "Refused on ",
  REVERT_TO_DRAFT: "Revert to Draft",
  CONFIRM_REVERT_TO_DRAFT: "Are you sure you want to revert to draft",
  SALES_ORDER_REVERTED: "Sales Order reverted to draft",
  EVENT_NAME: "Event Name",
  ADD_DISCOUNT: "Add Discount",
  EDIT_DISCOUNT: "Edit Discount",
  DISCOUNT: "Discount",
  DISCOUNT_TYPE: "Discount Type",
  DISCOUNT_PERCENTAGE: "Percentage Discount",
  DISCOUNT_AMOUNT: "Amount Discount",
  PERCENTAGE: "Percentage",
  FIXED_AMOUNT: "Fixed Amount",
  PREVIEW: "Preview",
  DISCOUNT_PERCENTAGE_PREVIEW: "Discount of {percentage}% = {amount}",
  DISCOUNT_AMOUNT_PREVIEW: "Discount of {amount}",
  CONFIRM_DELETE_DISCOUNT: "Are you sure you want to delete this discount?",
  DISCOUNT_DELETED: "Discount Deleted",
  DISCOUNT_UPDATED: "Discount Updated",
  DISCOUNT_ADDED: "Discount Added",
  DISCOUNTS: "Discounts",
  THE: "on ",
  ALLERGIES_AND_FOOD_INTOLERANCES: "Allergies and Food Intolerances",
  PURCHASE_ORDER_NUMBER: "Purchase Order Number",
  SENT_BY: "Sent by",
  SENT_TO: "Sent to",
  TO: "To",
  CC: "CC",
  BCC: "BCC",
  SENT_AT: "Sent on",
  FIRST_SENT_AT: "First sent on",
  CLIENT_REMINDERS: "Customer reminders",
  SENDING_HISTORY: "Sending history",
  SENDING_BY: "by {name}",
  SENDING_TYPE_FIRST_SENT: "First sent",
  SENDING_TYPE_RESENT: "Resent",
  SENDING_TYPE_REVISION_SENT: "Revision sent",
  SENDING_TYPE_REMINDER: "Automatic reminder",
  SENDING_TYPE_REVERTED_TO_DRAFT: "Reverted to draft",
  FIRST_SENT_ON: "First sent: {date}",
  LAST_REMINDER_ON: "Reminder: {date}",
  IS_SUBSIDIZED: "Subsidized Order",
  PRICING_TYPE: "Pricing Type",
  PRICING_TYPE_STANDARD: "Standard",
  PRICING_TYPE_SUBSIDIZED: "Subsidized",
  PRICING_TYPE_CATERER: "Caterer",
  PRICING_TYPE_COUPONS: "Coupons (To be invoiced)",
  ADD_COUPONS_SALES_ORDER: "Coupons quote",
  COUPONS_ITEM_NAME: "Name of the item to invoice",
  COUPONS_BILLING_PERIOD: "Billing period",
  COUPONS_AMOUNT: "Amount to invoice",
  COUPONS_REMAINING_HINT: "Remaining to invoice for this establishment: {amount}",
  COUPONS_ITEM_DESCRIPTION: "Coupons to be invoiced for the period from {start} to {end}",
  COUPONS_SALES_ORDER_ADDED: "Coupons quote created"
};
